import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../index'

const { env } = window

const useUpdateTenantMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const updateTenant = async (data) => {
    const url = encodeURI(`${env.apiUrl}/tenants/${data.id}`)
    const formData = new FormData()
    data.name !== undefined && formData.append('name', data.name)
    data.urlSlug !== undefined && formData.append('urlSlug', data.urlSlug)
    data.hidden !== undefined && formData.append('hidden', data.hidden)
    data.description !== undefined &&
      formData.append('description', data.description)
    const response = await securedFetch(url, {
      method: 'PATCH',
      body: formData
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ data }) => updateTenant(data),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error updating project settings'),
    onSuccess: () => {
      setMessage('Your project settings have been updated successfully.')
      queryClient.invalidateQueries({ queryKey: ['tenants'] })
    },
    onSettled: progressEnd
  })
}

export { useUpdateTenantMutation }
